// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DAoi","content":"styles_content__3ZAh1"};